module.exports = __webpack_public_path__ + "1e52836589bfa08421440ed37de29da3.mp3";